"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.erc20AllowanceAbi = void 0;
exports.erc20AllowanceAbi = [
    {
        constant: true,
        inputs: [
            {
                name: '_owner',
                type: 'address'
            },
            {
                name: '_spender',
                type: 'address'
            }
        ],
        name: 'allowance',
        outputs: [
            {
                name: '',
                type: 'uint256'
            }
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function'
    }
];
